/**
 * Filter function used to filter out times
 */
(function() {
    'use strict';

    angular.module('app').filter('timeFilter', function() {
        return function(input, times) {
            if (!times || times.length === 0) return input;
            var out = [];
            angular.forEach(input, function (item) {
                angular.forEach(times, function (time) {
                    if(item.dateCreated >= time.startDate && item.dateCreated <= time.endDate){
                        if (!isInArray(item, out)){
                            out.push(item);
                        }
                    }
                });
            });
            return out;
        };

        function isInArray(value, array) {
            return array.indexOf(value) > -1;
        }

    });

}());